import { getUserIdentifier } from '../reducers';

export default getUserIdentifier;
